// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rc-container {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0.32rem;
}
.rc-card {
  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.87), rgba(255, 255, 255, 0.95));
  border-radius: 0.24rem;
  width: 100%;
  margin: 0 auto;
  padding: 0.28rem 0.42rem;
}
.rc-card-hd {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 0.36rem;
  margin-bottom: 0.68rem;
}
.rc-card--title {
  display: inline-flex;
  align-items: center;
  color: #f53b3a;
  font-size: 0.44rem;
  font-weight: 600;
  text-align: center;
}
.rc-card--title::before {
  content: '';
  display: block;
  box-sizing: border-box;
  height: 0.03rem;
  width: 0.72rem;
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0), #f53b3a);
  border-radius: 0.06rem;
  margin-right: 0.12rem;
  flex: none;
  min-width: 0;
}
.rc-card--title::after {
  content: '';
  display: block;
  box-sizing: border-box;
  height: 0.03rem;
  width: 0.72rem;
  background-image: linear-gradient(to left, rgba(255, 255, 255, 0), #f53b3a);
  border-radius: 0.06rem;
  margin-left: 0.12rem;
  flex: none;
  min-width: 0;
}
.rc-input {
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(0, 0, 0, 0.7);
  font-size: 0.36rem;
  font-weight: 400;
  height: 0.96rem;
  padding: 0.24rem 0.48rem;
  background-color: #fff;
  border-radius: 0.2rem;
  border: none;
  width: 100%;
  box-sizing: border-box;
}
.rc-input > input {
  text-align: center;
  -webkit-box-pack: center;
  font-size: 0.36rem;
  outline: none;
  border: none;
  display: block;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
  color: #323233;
  line-height: inherit;
  background-color: transparent;
  resize: none;
  font-weight: 400;
  font-style: normal;
}
.rc-input > input::placeholder {
  color: rgba(0, 0, 0, 0.2);
  font-weight: 400;
  font-size: 0.36rem;
}
.rc-input::placeholder {
  color: rgba(0, 0, 0, 0.3);
}
.rc-btn {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  height: 0.96rem !important;
  color: #fff !important;
  font-size: 0.32rem !important;
  font-weight: 400 !important;
  padding: 0.24rem 0.48rem !important;
  border-radius: 0.2rem !important;
  margin-top: 0.34rem !important;
  border: none !important;
  width: 100% !important;
  box-sizing: border-box !important;
}
.rc-btn:disabled {
  opacity: 0.3;
  cursor: default;
}
.rc-rule {
  color: rgba(135, 135, 135, 0.6);
  font-size: 0.28rem;
  font-weight: 400;
  line-height: 1.5;
}
.rc-rule-list {
  list-style-type: decimal;
  margin-left: 0.32rem;
  font-size: 0.24rem;
  line-height: 1.5;
}
.rc-link {
  color: rgba(87, 129, 251, 0.6);
}
.rc-stepper {
  display: flex;
  justify-content: space-between;
  margin-top: 0.38rem;
  margin-bottom: 0.34rem;
}
.rc-stepper-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  font-size: 0.24rem;
}
.rc-stepper-item::after {
  position: absolute;
  content: '';
  border-bottom: 0.04rem solid rgba(245, 59, 58, 0.7);
  width: calc(150% - 1rem);
  top: 0.18rem;
  left: calc(50% + 0.4rem);
  z-index: 3;
}
.rc-stepper-item:first-child {
  align-items: flex-start;
}
.rc-stepper-item:last-child {
  align-items: flex-end;
}
.rc-stepper-item:first-child::after {
  left: 0.6rem;
}
.rc-stepper-item:last-child::after {
  content: none;
}
.rc-stepper-item .rc-stepper--counter {
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 0.36rem;
  height: 0.36rem;
  border-radius: 50%;
  background-color: rgba(245, 59, 58, 0.7);
  color: #fff;
  margin-bottom: 0.12rem;
}
.rc-stepper-item .rc-stepper--name {
  color: #878787;
  font-weight: 400;
}
.rc-alert {
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 0.28rem;
}
.rc-alert-bd {
  color: rgba(0, 0, 0, 0.5);
  font-size: 0.32rem;
  line-height: 1.5;
  text-align: center;
}
.rc-alert-ft {
  margin-top: 0.48rem;
  display: flex;
  justify-content: center;
}
.rc-alert-btn {
  height: 0.96rem !important;
  color: #fff !important;
  font-size: 0.32rem !important;
  font-weight: 400 !important;
  padding: 0.24rem 0.48rem !important;
  background-color: #f53b3a !important;
  border-radius: 0.2rem !important;
  border: none !important;
  width: 100% !important;
  display: block !important;
  box-sizing: border-box !important;
  max-width: 4.14rem !important;
}
.rc-alert-btn--orange {
  background-color: #ff9534 !important;
  margin-right: 0.16rem !important;
}
.rc-alert-btn:disabled {
  opacity: 0.3;
  cursor: default;
}
`, "",{"version":3,"sources":["webpack://./src/pages/marketing/components/redeem-code/index.less"],"names":[],"mappings":"AAAA;EACC,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;AACD;AAEA;EACC,kGAAA;EAKA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,wBAAA;AAJD;AAOA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AALD;AAQA;EACC,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAND;AASA;EACC,WAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;EACA,4EAAA;EACA,sBAAA;EACA,qBAAA;EACA,UAAA;EACA,YAAA;AAPD;AAUA;EACC,WAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;EACA,2EAAA;EACA,sBAAA;EACA,oBAAA;EACA,UAAA;EACA,YAAA;AARD;AAWA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;AATD;AAJA;EAeE,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,oBAAA;EACA,6BAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AARF;AASE;EACC,yBAAA;EACA,gBAAA;EACA,kBAAA;AAPH;AAYA;EACC,yBAAA;AAVD;AAaA;EACC,wBAAA;EACA,kCAAA;EACA,8BAAA;EACA,0BAAA;EACA,sBAAA;EACA,6BAAA;EACA,2BAAA;EACA,mCAAA;EACA,gCAAA;EACA,8BAAA;EACA,uBAAA;EACA,sBAAA;EACA,iCAAA;AAXD;AAcA;EACC,YAAA;EACA,eAAA;AAZD;AAeA;EACC,+BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAbD;AAgBA;EACC,wBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AAdD;AAiBA;EACC,8BAAA;AAfD;AAkBA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;AAhBD;AAmBA;EACC,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,OAAA;EACA,kBAAA;AAjBD;AAoBA;EACC,kBAAA;EACA,WAAA;EACA,mDAAA;EACA,wBAAA;EACA,YAAA;EACA,wBAAA;EACA,UAAA;AAlBD;AAqBA;EACC,uBAAA;AAnBD;AAsBA;EACC,qBAAA;AApBD;AAuBA;EACC,YAAA;AArBD;AAwBA;EACC,aAAA;AAtBD;AAyBA;EACC,kBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,wCAAA;EACA,WAAA;EACA,sBAAA;AAvBD;AA0BA;EACC,cAAA;EACA,gBAAA;AAxBD;AA2BA;EACC,sBAAA;EACA,sBAAA;EACA,sBAAA;AAzBD;AA4BA;EACC,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AA1BD;AA6BA;EACC,mBAAA;EACA,aAAA;EACA,uBAAA;AA3BD;AA8BA;EACC,0BAAA;EACA,sBAAA;EACA,6BAAA;EACA,2BAAA;EACA,mCAAA;EACA,oCAAA;EACA,gCAAA;EACA,uBAAA;EACA,sBAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;AA5BD;AA+BA;EACC,oCAAA;EACA,gCAAA;AA7BD;AAgCA;EACC,YAAA;EACA,eAAA;AA9BD","sourcesContent":[".rc-container {\n\tbox-sizing: border-box;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\theight: 100%;\n\tpadding: 16px;\n}\n\n.rc-card {\n\tbackground-image: linear-gradient(\n\t\tto bottom,\n\t\trgba(255, 255, 255, 0.87),\n\t\trgba(255, 255, 255, 0.95)\n\t);\n\tborder-radius: 12px;\n\twidth: 100%;\n\tmargin: 0 auto;\n\tpadding: 14px 21px;\n}\n\n.rc-card-hd {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tmargin-top: 18px;\n\tmargin-bottom: 34px;\n}\n\n.rc-card--title {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tcolor: #f53b3a;\n\tfont-size: 22px;\n\tfont-weight: 600;\n\ttext-align: center;\n}\n\n.rc-card--title::before {\n\tcontent: '';\n\tdisplay: block;\n\tbox-sizing: border-box;\n\theight: 1.5px;\n\twidth: 36px;\n\tbackground-image: linear-gradient(to right, rgba(255, 255, 255, 0), #f53b3a);\n\tborder-radius: 3px;\n\tmargin-right: 6px;\n\tflex: none;\n\tmin-width: 0;\n}\n\n.rc-card--title::after {\n\tcontent: '';\n\tdisplay: block;\n\tbox-sizing: border-box;\n\theight: 1.5px;\n\twidth: 36px;\n\tbackground-image: linear-gradient(to left, rgba(255, 255, 255, 0), #f53b3a);\n\tborder-radius: 3px;\n\tmargin-left: 6px;\n\tflex: none;\n\tmin-width: 0;\n}\n\n.rc-input {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tcolor: rgba(0, 0, 0, 0.7);\n\tfont-size: 18px;\n\tfont-weight: 400;\n\theight: 48px;\n\tpadding: 12px 24px;\n\tbackground-color: #fff;\n\tborder-radius: 10px;\n\tborder: none;\n\twidth: 100%;\n\tbox-sizing: border-box;\n\t> input {\n\t\ttext-align: center;\n\t\t-webkit-box-pack: center;\n\t\tfont-size: 18px;\n\t\toutline: none;\n\t\tborder: none;\n\t\tdisplay: block;\n\t\tbox-sizing: border-box;\n\t\twidth: 100%;\n\t\tmin-width: 0;\n\t\tmargin: 0;\n\t\tpadding: 0;\n\t\tcolor: #323233;\n\t\tline-height: inherit;\n\t\tbackground-color: transparent;\n\t\tresize: none;\n\t\tfont-weight: 400;\n\t\tfont-style: normal;\n\t\t&::placeholder {\n\t\t\tcolor: rgba(0, 0, 0, 0.2);\n\t\t\tfont-weight: 400;\n\t\t\tfont-size: 18px;\n\t\t}\n\t}\n}\n\n.rc-input::placeholder {\n\tcolor: rgba(0, 0, 0, 0.3);\n}\n\n.rc-btn {\n\tdisplay: flex !important;\n\tjustify-content: center !important;\n\talign-items: center !important;\n\theight: 48px !important;\n\tcolor: #fff !important;\n\tfont-size: 16px !important;\n\tfont-weight: 400 !important;\n\tpadding: 12px 24px !important;\n\tborder-radius: 10px !important;\n\tmargin-top: 17px !important;\n\tborder: none !important;\n\twidth: 100% !important;\n\tbox-sizing: border-box !important;\n}\n\n.rc-btn:disabled {\n\topacity: 0.3;\n\tcursor: default;\n}\n\n.rc-rule {\n\tcolor: rgba(135, 135, 135, 0.6);\n\tfont-size: 14px;\n\tfont-weight: 400;\n\tline-height: 1.5;\n}\n\n.rc-rule-list {\n\tlist-style-type: decimal;\n\tmargin-left: 16px;\n\tfont-size: 12px;\n\tline-height: 1.5;\n}\n\n.rc-link {\n\tcolor: rgba(87, 129, 251, 0.6);\n}\n\n.rc-stepper {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-top: 19px;\n\tmargin-bottom: 17px;\n}\n\n.rc-stepper-item {\n\tposition: relative;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tflex: 1;\n\tfont-size: 12px;\n}\n\n.rc-stepper-item::after {\n\tposition: absolute;\n\tcontent: '';\n\tborder-bottom: 2px solid rgba(245, 59, 58, 0.7);\n\twidth: calc(150% - 50px);\n\ttop: 9px;\n\tleft: calc(50% + 20px);\n\tz-index: 3;\n}\n\n.rc-stepper-item:first-child {\n\talign-items: flex-start;\n}\n\n.rc-stepper-item:last-child {\n\talign-items: flex-end;\n}\n\n.rc-stepper-item:first-child::after {\n\tleft: 30px;\n}\n\n.rc-stepper-item:last-child::after {\n\tcontent: none;\n}\n\n.rc-stepper-item .rc-stepper--counter {\n\tposition: relative;\n\tz-index: 5;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\twidth: 18px;\n\theight: 18px;\n\tborder-radius: 50%;\n\tbackground-color: rgba(245, 59, 58, 0.7);\n\tcolor: #fff;\n\tmargin-bottom: 6px;\n}\n\n.rc-stepper-item .rc-stepper--name {\n\tcolor: #878787;\n\tfont-weight: 400;\n}\n\n.rc-alert {\n\tbox-sizing: border-box;\n\tbackground-color: #fff;\n\tborder-radius: 14px;\n}\n\n.rc-alert-bd {\n\tcolor: rgba(0, 0, 0, 0.5);\n\tfont-size: 16px;\n\tline-height: 1.5;\n\ttext-align: center;\n}\n\n.rc-alert-ft {\n\tmargin-top: 24px;\n\tdisplay: flex;\n\tjustify-content: center;\n}\n\n.rc-alert-btn {\n\theight: 48px !important;\n\tcolor: #fff !important;\n\tfont-size: 16px !important;\n\tfont-weight: 400 !important;\n\tpadding: 12px 24px !important;\n\tbackground-color: #f53b3a !important;\n\tborder-radius: 10px !important;\n\tborder: none !important;\n\twidth: 100% !important;\n\tdisplay: block !important;\n\tbox-sizing: border-box !important;\n\tmax-width: 207px !important;\n}\n\n.rc-alert-btn--orange {\n\tbackground-color: #ff9534 !important;\n\tmargin-right: 8px !important;\n}\n\n.rc-alert-btn:disabled {\n\topacity: 0.3;\n\tcursor: default;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
